import request from '../request'

/**
 * Third party access (external service credentials) settings — MF-507.
 * Credenciales write-only: la contraseña nunca vuelve del backend (solo `hasPassword`).
 */

export const getAllThirdPartyAccess = () => request.get('setting/third-party-access').then((res) => res)

export const createThirdPartyAccess = (data) =>
  request.post('setting/third-party-access', data).then((res) => res)

export const updateThirdPartyAccess = (id, data) =>
  request.put(`setting/third-party-access/${id}`, data).then((res) => res)

export const deleteThirdPartyAccess = (id) =>
  request.delete(`setting/third-party-access/${id}`).then((res) => res)

// Dispara la sincronización (descarga de data del tercero). Responde { runId, status }.
export const syncThirdPartyAccess = (id) =>
  request.post(`setting/third-party-access/${id}/sync`).then((res) => res)

// MF-594 — Escribe el código que ACER envió por correo para continuar una sync que lo esperaba.
// Body { code, rememberDevice }. Responde { runId, status }.
export const submitThirdPartyAccessOtp = (id, data) =>
  request.post(`setting/third-party-access/${id}/sync/otp`, data).then((res) => res)

// Historial de sincronizaciones de una credencial.
export const getThirdPartyAccessSyncHistory = (id, limit = 20) =>
  request.get(`setting/third-party-access/${id}/sync-history`, { params: { limit } }).then((res) => res)
